<button
  mat-icon-button
  [matTooltip]="'Text alignment'"
  [intercomTarget]="'toolbar-context-menu-alignment'"
  [matMenuTriggerFor]="alignmentMenu"
>
  <fa-icon [icon]="icon"></fa-icon>
</button>
<mat-menu #alignmentMenu="matMenu" [overlapTrigger]="true">
  <button
    mat-menu-item
    (click)="alignmentChanged.emit(TextAlignment.Left)"
    [intercomTarget]="'toolbar-context-menu-alignment-left'"
  >
    <fa-icon [icon]="['far', 'align-left']"></fa-icon> Left
  </button>
  <button
    mat-menu-item
    (click)="alignmentChanged.emit(TextAlignment.Center)"
    [intercomTarget]="'toolbar-context-menu-alignment-center'"
  >
    <fa-icon [icon]="['far', 'align-center']"></fa-icon> Center
  </button>
  <button
    mat-menu-item
    (click)="alignmentChanged.emit(TextAlignment.Right)"
    [intercomTarget]="'toolbar-context-menu-alignment-right'"
  >
    <fa-icon [icon]="['far', 'align-right']"></fa-icon> Right
  </button>
</mat-menu>
